var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search" }, [
    _c("span", { staticClass: "search__label" }, [
      _vm._v(_vm._s(_vm.label) + " "),
      _vm.required
        ? _c("span", { attrs: { id: "asterics" } }, [_vm._v("*")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "search__container" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.currentValue,
            expression: "currentValue",
            modifiers: { trim: true },
          },
        ],
        staticClass: "search__input",
        attrs: { type: "text" },
        domProps: { value: _vm.currentValue },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.currentValue = $event.target.value.trim()
            },
            _vm.searchValue,
          ],
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "search__select",
          attrs: { type: "button" },
          on: { click: _vm.select },
        },
        [
          _c("i", {
            staticClass: "uk-icon-chevron-down",
            class: { opened: _vm.isOpen, closed: !_vm.isOpen },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _vm.resultList.length
      ? _c(
          "ul",
          { staticClass: "result-list" },
          _vm._l(_vm.resultList, function (e, i) {
            return _c(
              "li",
              {
                key: i,
                on: {
                  click: function ($event) {
                    return _vm.getValue(e)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.obj[e]))]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }